import { useT } from '../i18n';

export function Loading() {
  const t = useT();
  return (
    <div role="status" className="flex min-h-[30vh] items-center justify-center text-lab">
      <span className="mr-3 inline-block h-5 w-5 animate-spin rounded-full border-2 border-line border-t-fg" aria-hidden />
      {t('app.loading')}
    </div>
  );
}
